import { useEffect, useState } from "react";
import { addMaintenanceListener } from "@/api/client";

/**
 * Глобальний баннер «технічні роботи». Показуємо коли API повертає
 * 503 + {maintenance:true} (на cutover-вікно). Sticky зверху,
 * не дає юзеру нічого тиснути.
 */
export function MaintenanceBanner() {
  const [active, setActive] = useState(false);
  const [msg, setMsg] = useState("");

  useEffect(() => {
    return addMaintenanceListener((a, m) => {
      setActive(a);
      setMsg(m);
    });
  }, []);

  if (!active) return null;

  return (
    <div
      role="alert"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        background: "#FE6B04",
        color: "white",
        padding: "14px 16px",
        fontFamily: "var(--font-display, system-ui)",
        fontWeight: 600,
        fontSize: "0.8125rem",
        textAlign: "center",
        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
      }}
    >
      ⚙️ {msg || "Технічні роботи. Спробуй через кілька хвилин."}
    </div>
  );
}
